import * as signUp from './signUp';
import * as signIn from './signIn';
import * as leave from './leave';
import * as users from './users';
import * as notifications from './notifications';
import * as teams from './teams';
import * as contact from './contact';
import * as dashboard from './dashboard';

export default {
  signUp,
  signIn,
  leave,
  users,
  notifications,
  teams,
  contact,
  dashboard,
};
